





























































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'

// services
import { DailyControlsService } from '@/services/dailyControl'

// Models
import { Paginator } from '@/models'
import { DailyControlModel, FiltersDailyControlModel } from '@/models/dailyControl'

@Component({
    name: 'TableListItemDailyControls',
    components: {
        DataTable
    }
})
export default class TableListItemDailyControls extends Vue {
    @Prop({ required: true, type: Object }) readonly filters!: FiltersDailyControlModel

    loading = false
    countTotal = 0
    amountTotal = 0
    items: [DailyControlModel] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'employee.name',
            sortable: true,
            label: 'Empleado'
        },
        {
            key: 'workDescription.name',
            sortable: true,
            label: 'Descripción de Trabajo'
        },
        {
            key: 'price',
            sortable: true,
            label: 'Tarifa'
        },
        {
            key: 'amount',
            sortable: true,
            label: 'Cantidad'
        },
        {
            key: 'total',
            sortable: true,
            label: 'Importe'
        },
        {
            key: 'date',
            sortable: true,
            label: 'Fecha'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '8%'
            }
        }
    ]

    created () {
        this.getDailyControlsWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getDailyControlsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getDailyControlsWithPagination()
    }

    async getDailyControlsWithPagination () {
        this.loading = true
        const response = await DailyControlsService.getWithPagination(this.pagination.perPage, this.pagination.currentPage, this.filters)
        const { amountTotal, countTotal } = await DailyControlsService.getTotals(this.filters)
        this.amountTotal = amountTotal
        this.countTotal = countTotal
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
